import ReactMarkdown from "react-markdown";
import React from "react";
import { replacePlaceholders } from "../../utils/placeholders";

interface LabelProps {
    text: string | string[] | undefined;
}

export const Label = ({ text }: LabelProps) => {
    const processedText = React.useMemo(() => {
        if (typeof text === "undefined") {
            return "";
        }
        if (typeof text === "string") {
            return text;
        }
        if (Array.isArray(text)) {
            return text.join("\n\n");
        }
        return String(text);
    }, [text]);

    return (
        <div className="param-label mb-05rem md">
            <ReactMarkdown>{replacePlaceholders(processedText)}</ReactMarkdown>
        </div>
    );
}